import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, Upload } from 'lucide-react';

export function ParticipantDocumentEmptyState({ canManage, onUpload }) {
  return (
    <div className="text-center py-14 border rounded-lg bg-muted/10" data-testid="doc-empty-state">
      <div className="mx-auto w-12 h-12 rounded-full bg-muted/40 flex items-center justify-center mb-4">
        <FileText className="w-6 h-6 text-muted-foreground/60" />
      </div>
      <p className="text-sm font-medium text-foreground">No documents uploaded yet</p>
      <p className="text-xs text-muted-foreground mt-1">
        {canManage
          ? 'Upload documents like service agreements, consent forms, or ID copies.'
          : 'Documents will appear here once uploaded.'}
      </p>
      {canManage && (
        <Button size="sm" onClick={onUpload} className="mt-4" data-testid="empty-upload-btn">
          <Upload className="w-3.5 h-3.5 mr-1.5" /> Upload Document
        </Button>
      )}
    </div>
  );
}
